import { useMediaQuery } from 'react-responsive';

const GalleryOverlay = ({ count, children }) => {
  const isExtraSmallScreen = useMediaQuery({ query: '(max-width: 640px)' });

  return (
    <>
      {children}
      <span className="absolute hover:cursor-pointer top-0 left-0 rounded-lg w-full h-full flex items-center justify-center bg-black bg-opacity-50 text-white text-xl pointer-events-none">
        {isExtraSmallScreen ? `+${count}` : `View all +${count}`}
      </span>
    </>
  );
};

export default GalleryOverlay;
